import { injectGlobal } from "vue3-styled-components";

injectGlobal`
@font-face {
    font-family: 'Pretendard-Regular';
    src: url('./fonts/Pretendard-Regular.otf') format('opentype');
    font-weight: 400;
    font-style: normal;
    font-display: swap;
}

@font-face {
    font-family: 'Pretendard-Bold';
    src: url('./fonts/Pretendard-Bold.otf') format('opentype');
    font-weight: 700;
    font-style: normal;
    font-display: swap;
}

body, input, textarea, button, select, a, .swal2-popup, .swal2-modal {
    font-family: 'Pretendard-Regular', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
}

body {
    margin: 0; 
    font-size: 17px;
}

table, th, td {
    border-collapse: collapse;
}

th {
    border-bottom : solid 1px #99B0CB;
}

td {
    border-bottom : solid 1px #D8D8D8;
}

a {
    text-decoration: none;
    color: #000;
}

input {
    padding: 5px;
    border: 1px solid #D8D8D8;
    border-radius: 3px;
    outline: none;
    font-size: 15px;
}

.swal2-toast {
    margin-top: 50px !important;
    font-size: 15px !important;
}

.tenWidth {
    width: 10%;
}

.fifteenWidth {
    width: 15%;
}

.twentyWidth {
    width: 20%;
}

.twentyFiveWidth {
    width: 25%;
}

.thirtyWidth {
    width: 30%;
}

.thirtyFiveWidth {
    width: 35%;
}

.fortyWidth {
    width: 40%;
}

.fortyFiveWidth {
    width: 45%;
}

.fiftyWidth {
    width: 50%;
}

.fiftyFiveWidth {
    width: 55%;
}

.sixtyWidth {
    width: 60%;
}

.sixtyFiveWidth {
    width: 65%;
}

.seventyWidth {
    width: 70%;
}

.seventyFiveWidth {
    width: 75%;
}

.eightyWidth {
    width: 80%;
}

.eightyFiveWidth {
    width: 85%;
}

.ninetyWidth {
    width: 90%;
}

.ninetyFiveWidth {
    width: 95%;
}

.hundredWidth {
    width: 100%;
}
`;

export default {};